export default __webpack_public_path__ + "static/media/tick.130d0da4.svg";